module.exports = __webpack_public_path__ + "static/media/icon_telephone_white.3890115b.svg";